import angular from 'angular';

import csmUIDateInput from '../dateInput/dateInput';
import csmUINumericStepper from '../numericStepper/numericStepper';
import dateTimePickerTemplate from './dateTimePicker.template.html';

export default angular
  .module('csm.ui.dateTimePicker', [csmUIDateInput, 'csm.ui.numericStepper'])
  /**
   * @ngdoc    component
   * @module   csm.ui
   * @name     csm.ui.dateTimePicker.component:dateTimePicker
   *
   * @param    {object} ngModel Data binding for a date value.
   *
   * @description
   * Provides ability to set date and time.
   * Utilizes dateInput and numericStepper components to
   * create a date and time selector.
   **/
  .component('dateTimePicker', {
    require: { ngModelCtrl: 'ngModel' },
    template: dateTimePickerTemplate,
    controller: function ($scope, $element, Tools) {
      /** Self Reference. */
      var mThis = this;

      /*----------------------------------------------------*/
      /* Called when the values of date or time are changed */
      /* and updates them on the model when different.      */
      /*----------------------------------------------------*/
      function buildDate() {
        /** Clone the date to avoid changing the original value */
        var d = cloneDate(mThis.date);

        if (d) {
          var isDayStart = mThis.hour == 12 && mThis.isAM;

          if (!isNaN(mThis.hour))
            d.setHours(
              isDayStart
                ? 0
                : mThis.hour + (mThis.isAM || mThis.hour == 12 ? 0 : 12)
            );

          d.setMinutes(mThis.minutes);
        }

        if (d != mThis.ngModelCtrl.$viewValue)
          mThis.ngModelCtrl.$setViewValue(d);
      }

      /*-------------------------------------------------------*/
      /* Clone the date so we do not alter the original value. */
      /* Strip time from date object.                          */
      /*-------------------------------------------------------*/
      function cloneDate(source) {
        if (!source) return null;

        return new Date(
          source.getFullYear(),
          source.getMonth(),
          source.getDate()
        );
      }

      /*--------------------------------------------------------------------*/
      /* This is for the minutes input, which uses the numeric stepper      */
      /* component. When minutes rollover or rollback, trigger increment    */
      /* or decrement of the hour. isRollover indicates incrementing past   */
      /* the maximum when true or decrementing past the minimum when false. */
      /*--------------------------------------------------------------------*/
      mThis.minLoop = function (isRollover) {
        if (isRollover) {
          if (++mThis.hour > 12) mThis.hour = 1;
        } else {
          if (--mThis.hour < 1) mThis.hour = 12;
        }
      };

      /*----------------------------------------*/
      /* Set up ngModelController functionality */
      /*----------------------------------------*/
      mThis.$onInit = function () {
        /*-------------------------------------------------------------*/
        /* Render is called when model is changed outside of component */
        /*-------------------------------------------------------------*/
        mThis.ngModelCtrl.$render = function () {
          var extDate = mThis.ngModelCtrl.$viewValue;

          mThis.date = extDate ? cloneDate(extDate) : null;
          mThis.hour = extDate ? extDate.getHours() % 12 || 12 : NaN;
          mThis.minutes = extDate ? extDate.getMinutes() : NaN;
          mThis.isAM = extDate ? extDate.getHours() < 12 : null;
        };

        /*-----------------------------------------------------------------------*/
        /* Update the model every time the date, minutes, or AM property changes */
        /*-----------------------------------------------------------------------*/
        $scope.$watch('$ctrl.date', buildDate);
        $scope.$watch('$ctrl.minutes', buildDate);
        $scope.$watch('$ctrl.isAM', buildDate);
      };

      /*-------------------------------------------------------------------------------*/
      /* Set up watch to monitor hour attribute for rollover/rollback to toggle AM/PM. */
      /* Toggle isAM when hour is 11 and prevHour is 12 or vice versa.                 */
      /* This is to ensure proper rollover of time.                                    */
      /*-------------------------------------------------------------------------------*/
      $scope.$watch('$ctrl.hour', function (hour, prevHour) {
        if (hour * prevHour == 132) mThis.isAM = !mThis.isAM;
        else buildDate();
      });

      /*------------------------------------------------*/
      /* Set up watch to monitor the disabled attribute */
      /*------------------------------------------------*/
      $scope.$watch(
        function () {
          return $element[0].hasAttribute('disabled');
        },
        function (disabled) {
          mThis.isDisabled = disabled;
        }
      );
    }
  }).name;
